// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"45007844","610":"f9ef44d0","787":"b549bb00"}[chunkId] + ".chunk.js";
};